import { render, staticRenderFns } from "./api-console.vue?vue&type=template&id=68028cd6&scoped=true"
import script from "./api-console.vue?vue&type=script&lang=js"
export * from "./api-console.vue?vue&type=script&lang=js"
import style0 from "./api-console.vue?vue&type=style&index=0&id=68028cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68028cd6",
  null
  
)

export default component.exports